"use client";
import React from "react";
import { jointImgUploadByUser } from "@/lib/commonService";
import ReviewItem from "./ReviewItem";
import classnames from "classnames";
import stl from "./productReview.module.scss";
import WithPhotoSwiper, {
    WrapperProps,
} from "@/src/components/Upload/WithPhotoSwiper";
import { PhotoSwiperTitle } from "@/src/components/Upload/PhotoSwiper";
import { IReviewAndFq } from "@/store/modules/reviewAndFq";
import {
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";
import ProductReviewClient from "./ProductReviewClient";
import { FmRating } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";

interface IProps extends IReviewAndFq {
    customerReviews?: any;
    // openUpload: (arg: boolean) => void;
    productDetail: Partial<IInitedInfo & IProductDetailsInfo>;
    language: string;
}

type IProductReviewProps = WrapperProps<IProps>;

const ProductReview: React.FC<IProductReviewProps> = (props) => {
    const {
        commentList,
        commentNum,
        starNum,
        mapPhotoSwiperImg,
        openSetPhotoSwiper,
        productDetail,
        language,
        customerReviews = "",
    } = props;
    const { t } = useTranslation(["productDetail", "review"]);
    const reviewList = commentList
        ? commentList.map((item: any) => {
              return {
                  reviews_photo: item.reviews_photo
                      ? jointImgUploadByUser(item.reviews_photo)
                      : "",
                  title: PhotoSwiperTitle(item, true),
              };
          })
        : [];
    const imgs: any = mapPhotoSwiperImg?.(reviewList, "reviews_photo");

    return (
        <ProductReviewClient commentNum={commentNum}>
            {/* children[0] */}
            <div
                className={classnames(
                    "default_layout",
                    stl["reviews-title-container"],
                    stl["add-higher-level"],
                )}
            >
                <p className={stl["reviews-title"]}>
                    {commentNum
                        ? `${
                              customerReviews || t("productDetail:Reviews")
                          }(${commentNum})`
                        : customerReviews || t("productDetail:Reviews")}
                </p>
                {commentNum > 0 && (
                    <FmRating
                        value={starNum}
                        hiddenRatingNum
                        iconClassName={stl["icon-size"]}
                    />
                )}
            </div>

            <>
                {commentNum > 0 ? (
                    <>
                        <div className={stl["comment-list-wrapper"]}>
                            {commentList.map((item: any, index: number) => (
                                <ReviewItem
                                    data={item}
                                    key={index}
                                    productId={productDetail.products_id!}
                                    imgClick={openSetPhotoSwiper}
                                    imgs={imgs}
                                />
                            ))}
                        </div>
                        {/* commentNum > 2 && ...*/}
                    </>
                ) : (
                    <>
                        {/* 没有评论的空状态 */}
                        <div className={stl["no-comment"]}>
                            {t("review:ShareYourShopping")}
                        </div>
                    </>
                )}
            </>
        </ProductReviewClient>
    );
};

export default WithPhotoSwiper<IProps>(ProductReview)();
